<div class="page">
  <pla-main-nav-chips></pla-main-nav-chips>
  <div class="content-container extended">
    <div class="-ps-5 side-container mb-3">
      <div class="pt-0 position-relative">
        <pla-side-nav></pla-side-nav>
      </div>
    </div>
    <div class="center-content-container position-relative">
      <div
        class="px-0 px-md-1 py-0 me-0">
        <div>
          <!-- CONTENT -->
          <div class="w-100">
            <div>
              <div style="" class="py-4 px-4 px-md-5">
                <div class="pb-5 pt-5">
                  <h1 class="text-center text-md-start fs-md-26 fs-mb-22 fw-normal mb-3">
                    Frequently Asked Questions
                  </h1>
                </div>
                <div class="w-100 px-3 px-md-0 pb-5">
                  <pla-faq [faq]="faq"></pla-faq>
                </div>
              </div>

              <div class="py-1 py-md-5"></div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="false">
  <div class="page-width">
    <div class="mt-3 bootstrap">
      <!-- <pla-faq [faq]="infoContent"></pla-faq> -->
      <div>
        <p class="d-block h2 fw-bold text-start">About Us</p>
        <p class="fw-light">
          PlateX is a UK technology company whose sole endeavour is to simplify
          the cherished registration market.
        </p>
        <p class="fw-light">
          Cutting edge search technologies help our users find their perfect
          registration and our price comparison service locates the best possible
          deal.
        </p>
        <p class="fw-light">
          For sellers we provide a cost-effective, commission-free advertising
          service to an unrivalled marketplace designed specifically to promote
          liquidity.
        </p>
      </div>

      <div>
        <p class="d-block h2 fw-bold text-start">Our Strategy</p>
        <p class="fw-light">
          To simplify the cherished registration market in the UK, our strategy is
          to:
        </p>
        <ul class="fw-light">
          <li class="fw-light">
            be the place consumers turn to first and engage with most
          </li>
          <li class="fw-light">
            provide unrivalled exposure and leads for our customers
          </li>
          <li class="fw-light">
            innovate to create a simpler and more liquid market
          </li>
        </ul>
      </div>

      <div>
        <p class="d-block h2 fw-bold text-start">Our Technology</p>
        <p class="fw-light">
          At the core of all features on the PlateX platform is our proprietary
          search algorithm PLATO, named after another famous deep thinker. PLATO
          allows users to search the entire marketplace of registrations including
          those offered for resale by dealers, private owners, and millions of
          unissued government stock, all in a single search.
        </p>
        <p class="fw-light">
          Within just a few seconds PLATO retrieves and ranks search results by
          numerous datapoints including pattern match, recognisability and
          phonetics while minimising blight caused by additional characters.
        </p>
        <p class="fw-light">
          As an autonomous algorithm PLATO continues to learn and adapt with every
          search it undertakes. In addition our users help PLATO learn to improve
          the quality of ranking through the Vote Up / Down icons beneath each
          search result. To ensure that users are guaranteed to be shown the best
          result we safeguard the integrity of the PLATO search by not offering
          any service to improve the ranking of a registration for fees or
          affiliation.
        </p>
      </div>
    </div>
  </div>

  <div class="section page-width">
    <pla-glossary [searchTerm]="glossaryUrl"></pla-glossary>
  </div>
</div>
